import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { AppConst } from '../../constants/app-const';
import { WeatherNewsApiResponseSrf } from '../../services/weather-news.service';
import { UtilFunctions } from '../../utils/util-functions';

export interface DialogData {
  temperature: number;
  srf: WeatherNewsApiResponseSrf[];
}

export interface DialogSrf {
  date: number;
  hour: number;
  wx: number;
  wxIconUrl: string;
  temp: number;
}

@Component({
  selector: 'app-today-wn-dialog',
  templateUrl: './today-wn-dialog.component.html',
  styleUrls: ['./today-wn-dialog.component.scss'],
})
export class TodayWnDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TodayWnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  todaySrf: DialogSrf[] = [];

  ngOnInit(): void {
    for (let s of this.data.srf) {
      const srf: DialogSrf = {
        date: UtilFunctions.getDateFromString(s.date),
        hour: UtilFunctions.getHourFromString(s.date),
        wx: s.wx,
        wxIconUrl: this.getWxIconUrl(s.wx),
        temp: s.temp,
      };

      if (UtilFunctions.wnIsTodayFromString(s.date)) {
        this.todaySrf.push(srf);
      }
    }
  }

  getWxIconUrl(wx: number) {
    return AppConst.WEATHER_NEWS_API_ICON_URL + wx + '.png';
  }
}
